import { get } from '../../api';
import { DefaultResponseDTO, Resource } from '../../constants';

export const getRankingTypesDropdownRequest = (): Promise<DefaultResponseDTO<Resource[]>> => {
  return get<DefaultResponseDTO<Resource[]>>(`/ranking-types/dropdown`);
};
